/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type CandidateOpportunityEntity, candidateOpportunitySchema } from '@axiom/domain';
import { CandidateStatus } from '../../../enums/generated/candidate-status';
import { interviewCandidateDtoSchema } from './interview-candidate-dto';

export const opportunityInterviewResultCandidateOpportunityDtoSchema = candidateOpportunitySchema.pick({ "candidateStatusUpdatedAt": true }).extend({ "candidate": z.lazy(() => interviewCandidateDtoSchema).nullish(), "candidateStatus": z.nativeEnum(CandidateStatus).nullish() });
export type OpportunityInterviewResultCandidateOpportunityDto = Pick<CandidateOpportunityEntity, "candidateStatusUpdatedAt"> & z.infer<typeof opportunityInterviewResultCandidateOpportunityDtoSchema>;
